import React from "react";

const Tiktok = ({fill}) => {
  return (
    <svg
      className="social-icon-fill"
      width={30}
      height={30}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.7672 1H18.2672V2.93103C18.2672 7.31599 21.8219 10.8707 26.2069 10.8707V12.3707C22.8756 12.3707 19.9473 10.6451 18.2672 8.03892V22.2414C18.2672 26.3883 14.9055 29.75 10.7586 29.75C6.61172 29.75 3.25 26.3883 3.25 22.2414C3.25 18.0945 6.61172 14.7328 10.7586 14.7328V16.2328C7.44015 16.2328 4.75 18.9229 4.75 22.2414C4.75 25.5598 7.44015 28.25 10.7586 28.25C14.0771 28.25 16.7672 25.5598 16.7672 22.2414V1Z"
        fill={fill}
      />
    </svg>
  );
};

export default Tiktok;
